import React from "react";
import Header from "../Header/Header";
import Shop from "../Shop/Shop";

const Home = () => {
  return (
    <div>
      <Header></Header>
      <Shop></Shop>
    </div>
  );
};

export default Home;
